import React from 'react';

const BottomNav = ({ activeTab, setActiveTab, cartLength }) => {
  return (
    <div className="bottom-nav" style={{ zIndex: 1100, position: "fixed", bottom: 0, width: "100%" }}>
      {["菜单", "订单", "社区", "我的"].map((tab) => (
        <button 
          key={tab} 
          className={activeTab === tab ? "active" : ""} 
          onClick={() => setActiveTab(tab)} 
          style={{ position: "relative" }}
        >
          {tab}
          {tab === "订单" && cartLength > 0 && (
            <span style={{ 
              position: "absolute", 
              top: "8px", 
              right: "20%", 
              background: "#E85A33", 
              color: "#FFF", 
              fontSize: "12px", 
              fontWeight: "900", 
              padding: "2px 6px", 
              borderRadius: "50%", 
              border: "2px solid #000", 
              boxShadow: "2px 2px 0 #000", 
              lineHeight: "1" 
            }}>
              {cartLength}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default BottomNav;
